






































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import SuporteSalasRoboticasStore from '@/components/Suporte/Store/SuporteSalasRoboticasStore'
import ModalSuporteSalaRobotica from '@/components/Suporte/components/ModalSuporteSalaRobotica.vue'
import { useHospitais } from '@/composables'

@Component({
  components: { ModalSuporteSalaRobotica },
})
export default class ViewSuporteSalasRoboticas extends Vue {
  loadingTabela: boolean = false
  loadingAdicionar: boolean = false
  loadingItem: string = ''

  get store() {
    return getModule(SuporteSalasRoboticasStore, this.$store)
  }

  get hospitalId() { return this.store.hospitalId }
  set hospitalId(value: string) { this.store.setHospitalId(value) }

  get hospitais() {
    return useHospitais.hospitaisByCurrentUser.map((h) => {
      const hospital = h
      hospital.id = _.toUpper(h.id)
      hospital.nome = _.toUpper(h.nome)
      return hospital
    })
  }

  fetchHospitais() {
    return useHospitais.loadHospitaisByCurrentUser()
  }

  get headers() {
    return [
      { text: 'Nome do Robô', value: 'descricao', sortable: false },
      { text: 'Status', value: 'status', align: 'center', sortable: false },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get salasRoboticas() { return this.store.salasRoboticas }

  statusDisplay(status: string) {
    return status === 'Removido' ? 'Inativo' : status
  }

  async hospitalChange(id: any) {
    this.store.clearSalasRoboticas()
    this.store.setHospitalId(id)
    this.loadingTabela = true
    await this.store.getSalasRoboticas()
    this.loadingTabela = false
  }

  async adicionarRobo() {
    this.loadingAdicionar = true
    this.store.setMode({ mode: 'CREATE' })
    this.store.clearSalaRobotica()
    this.store.setModal({ name: 'salaRobotica', value: true })
    this.loadingAdicionar = false
  }

  async editarRobo(item: any) {
    this.loadingItem = item.id
    this.store.setMode({ mode: 'EDIT' })
    this.store.setSalaRobotica({
      id: item.id,
      descricao: item.descricao,
      status: item.status === 'Removido' ? 'Inativo' : item.status,
      hospitalId: item.hospitalId,
    })
    this.store.setModal({ name: 'salaRobotica', value: true })
    this.loadingItem = ''
  }

  beforeDestroy() {
    this.store.clearSalasRoboticas()
    this.store.clearHospitalId()
  }
}
